import AppUtils from "./apputlis";
import axios from 'axios';
import AesUtils from "../network/AesUtils";

console.disableYellowBox = true // 关闭全部黄色警告 
// console.log('process.env.REACT_APP_ENV', process.env.REACT_APP_ENV);
if (process.env.REACT_APP_ENV == 'production') {
    console.log = function () { }
}

export default class AppConfig {

    
    static domains = [
        "https://jk.b1gbed.cn/",
        "https://jk.b1ggrv.cc/",
        "https://jk.b1ttvc.cn/",
        "https://jk.b1wwbv.cn/",
        "https://jk.b1wazsx.cn/",
        "https://jk.b1edca.cn/"
    ];
    //测试
    // static domains = [
    //     "https://jk.brfsdf.cn",
    //     "https://jk.bghrc.cn",
    //     "https://jk.bwszax.cc",
    //     "https://jk.btfsdc.cn"
    // ];

    

    static deviceid = AppUtils.getUniqueID();
    static channelid = 7;
    static freeLanchannelid = 7;
    //每次打包+1
    static version = 130;
    static phpVersion = 1
    //直接用测试服
    // static hostApi = 'https://bdylive.4d5s4.cn/';
    //直接用线上
    static hostApi = AppConfig.getUrl()
    // static hostApi = (process.env.REACT_APP_ENV == 'production') ? AppConfig.getUrl():'https://bdylive.4d5s4.cn/';

    static appID = 'com.tqtv.livetv';
    static isAndroid = navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Adr') > -1; //android终端
    static isiOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    static APP_NAME = '体球直播';
    static isInitHostApi = false;
    static errDomainIndex = 0;
    static TXDOMAINCFG = "https://livejk-1309827338.cos.accelerate.myqcloud.com/domain.config";
    static ALDOMAINCFG = "https://f7tv.oss-cn-hongkong.aliyuncs.com/domain.config";
    static tabLineColoor = '#ec2835'
    static tabColor = '#2f2f2f'
    static tabSelColor = '#2f2f2f'


    static getUrl() {
        //第一次进来，获取历史的baseurl
        let url = AppUtils.getStorageItem('DOMAIN_LIST');
        if (url == null || url == undefined || url == '') {
            url = AppConfig.domains[Math.floor(Math.random() * AppConfig.domains.length)];
        }
        if (url[url.length - 1] != '/') {
            url = url + '/';
        }
        console.log('getUrl===>', url);
        AppConfig.checkDomains();
        return url;
    }


    static endWith(s, r) {
        var d = s.length - r.length;
        return (d >= 0 && s.lastIndexOf(r) == d);
    }

    static checkDomains() {
        AppConfig.checkHttp(AppConfig.domains, true);
    }

    static checkHttp(domains, con) {
        for (let i = 0; i < domains.length; i++) {
            //循环发送网络请求
            AppConfig.pingDomain(domains[i], domains.length, con);
        }
    }

    static pingDomain(url, len, con) {
        if (url[url.length - 1] != '/') {
            url = url + '/';
        }
        let u = url + 'app/encryptionVersion';
        axios.get(u).then(response => {
            try {
                if (response && response.code == 200) {
                    //如果banseurl没设置过，去设置
                    if (!AppConfig.isInitHostApi) {
                        AppUtils.setStorageItem('DOMAIN_LIST', url);
                        AppConfig.hostApi = url;
                        AppConfig.isInitHostApi = true;
                        console.log('hostApi===>', url);
                    }
                } else {
                    //可能没解密，去解密看看
                    let result = AesUtils.decrypt(response.data);
                    result = JSON.parse(result);
                    if (result.code == 200) {
                        if (!AppConfig.isInitHostApi) {
                            AppUtils.setStorageItem('DOMAIN_LIST', url);
                            AppConfig.hostApi = url;
                            AppConfig.isInitHostApi = true;
                            console.log('hostApi===>', url);
                        }
                    } else {
                        //没成功。去获取服务器的url
                        AppConfig.errDomainIndex++;
                        if (len == AppConfig.errDomainIndex && con) {
                            AppConfig.getTxDomains();
                        }
                    }
                }

            } catch (error) {
                AppConfig.errDomainIndex++;
                if (len == AppConfig.errDomainIndex && con) {
                    AppConfig.getTxDomains();
                }
            }
        }).catch(err => {
            AppConfig.errDomainIndex++;
            if (len == AppConfig.errDomainIndex && con) {
                AppConfig.getTxDomains();
            }
        })
    }



    static getTxDomains() {
        AppConfig.getDomains(AppConfig.TXDOMAINCFG)
    }

    static getAlDomains() {
        AppConfig.getDomains(AppConfig.ALDOMAINCFG)
    }

    static getDomains(u) {
        let to = u == AppConfig.TXDOMAINCFG;
        axios.get(u).then(response => {
            try {
                let d = response[AppConfig.appID];
                AppConfig.errDomainIndex = 0;
                AppConfig.checkHttp(d, to);
            } catch (error) {
                if (to) {
                    AppConfig.getAlDomains();
                }
            }
        }).catch(err => {
            if (to) {
                AppConfig.getAlDomains();
            }
        })
    }
}